module.exports = __webpack_public_path__ + "img/farizon-vilsans.4d76cca2.jpg";